<template>
  <section id="works" class="common-padding mb-20">
    <div class="flex flex-col">
      <h3
        id="selectedWorks"
        v-html="selectedWorks"
        class="heading-1 text-start leading-none font-bold uppercase"
      ></h3>
      <p
        class="heading-1 text-flax-smoke-400 text-opacity-50 hidden w-4/5 text-end font-extrabold sm:block"
      >
        ( {{ selectedWorksProps.length }} )
      </p>

      <div
        id="selected-works-text"
        class="md:column-gap text-flax-smoke-300 mt-[5%] grid grid-cols-12 justify-end opacity-0 lg:grid"
      >
        <p
          class="heading-6 text-flax-smoke-300/85 col-span-4 text-center text-nowrap lg:col-start-2"
        >
          (
          <span class="inline sm:hidden">{{ selectedWorksProps.length }} </span>
          PROJECTS )
        </p>
        <p
          class="heading-4 font-fancy col-span-8 w-full text-balance sm:font-semibold lg:col-span-7"
        >
          Featured client projects that have been meticulously crafted with
          passion and purpose over the years.
        </p>
      </div>
    </div>

    <div
      class="sm:column-gap relative mt-12 grid size-full grid-cols-12 lg:mt-[10%]"
    >
      <div
        class="text-flax-smoke-100 sticky top-12 col-span-5 hidden h-fit w-full overflow-hidden text-[22vw] leading-[0.8] font-semibold md:flex"
      >
        <span id="index" class="font-title! relative -tracking-wider">{{ formattedIndex }}.</span>

      </div>
      <aside
        @mouseenter="showCursor"
        @mouseleave="hideCursor"
        class="relative col-span-full flex flex-col space-y-10 md:col-span-7"
      >
        <div
          v-for="(work, i) in selectedWorksProps"
          :key="i"
          class="work-card @container"
        >
          <a class="group" target="_blank" :href="work.url">
            <div
              class="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden rounded-lg"
            >
             <img
                :src="work.imageBg"
                alt="work background"
                :class="work.name === 'EZON Website Redesign'
                  ? 'w-full h-full object-contain'
                  : 'w-full h-full object-contain sm:object-cover object-center'
                "
              />

            </div>
            <div>
              <p class="heading-6 font-title! mt-[2%] mb-[1%] leading-none">
                {{ work.category }}
              </p>
              <div class="items-center justify-between sm:flex">
                <h3 class="heading-3 font-title! font-bold uppercase">
                  {{ work.name }}
                </h3>
                <div class="flex gap-1.5 select-none">
                  <p
                    class="border-flax-smoke-300 hover:bg-flax-smoke-300 hover:text-flax-smoke-900 
                    rounded-full border px-4 py-2 text-lg sm:text-sm leading-none whitespace-nowrap
                    transition-[background-color,color] duration-500 ease-in-out"
                    v-for="tag in work.tags"
                    :key="tag"
                  >
                    <span>{{ tag }}</span>
                  </p>
                 
                </div>
              </div>
            </div>
          </a>
        </div>
      </aside>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { computed, onBeforeMount, onMounted, ref, useTemplateRef } from 'vue';
  import gsap from 'gsap';
  import { useWindowSize } from '@vueuse/core';
  import BSF from '@/assets/images/BSF.png';
  import CMRS from '@/assets/images/CMRS.png';
  import Stream from '@/assets/images/Stream.png';
  import Paytrack from '@/assets/images/Paytrack.png';
  import Skill from '@/assets/images/Skill.png';
  import Paypal from '@/assets/images/Paypal.jpeg';
  import CRM from '@/assets/images/CRM.png';
  import partscentral from '@/assets/images/partscentral.png';
  import AOW from '@/assets/images/AOW.jpeg';
  import Ezon from'@/assets/images/Ezon.png';
  const videoRefs = useTemplateRef<HTMLVideoElement[]>('videoRefs');

  const isSmallScreen = computed(() => {
    return useWindowSize().width.value < 768;
  });
  const index = ref(0);
  const selectedWorks = ref('Selected Projects /');

  const tl = gsap
    .timeline({ defaults: { duration: 0.25 } })
    .to(['#cursor', '#inner'], {
      scale: 1,
      opacity: 1,
    })
    .paused(true);

  const showCursor = () => {
    tl.play();
  };
  const hideCursor = () => {
    tl.reverse();
  };

   const formattedIndex = computed(() => {
  const num = index.value + 1
  return num < 10 ? `0${num}` : `${num}`
})

  const selectedWorksProps = [
    {
    name: "Part Central E-Commerce Website",
    category: "UI/UX & E-Commerce",
    tags: ["Dashboard", "E-commerce"],
    videoSrc: "",
    imageBg: partscentral,
    url: "https://partscentral.us/",
  },
  {
    name: "AOW Information Technology Website",
    category: "UI/UX & Web Design",
    tags: ["Website", "Responsive Design"],
    videoSrc: "", // add preview video if you have
    imageBg: AOW, // add background image
    url: "https://aow.co.in/",
  },
  {
    name: "Bharat Sports Foundation Website",
    category: "UI/UX & Web Design",
    tags: ["Website", "Design System"],
    videoSrc: "",
    imageBg: BSF,
    url: "https://bharatsportsfoundation.org/",
  },
    {
    name: "CRM Dashboard – Part Central",
    category: "UI/UX & Dashboard Design",
    tags: ["Figma", "Dashboard"],
    videoSrc: "",
    imageBg: CRM,
    url: "https://www.figma.com/design/cUybypZs5qHkCzgYUSlftK/CRM--Partcentral",
  },
   {
    name: "SkillKwiz – Skill Assessment Platform",
    category: "UI/UX Platform",
    tags: ["Assessment", "Platform"],
    videoSrc: "",
    imageBg: Skill,
    url: "https://www.figma.com/design/6S32UsKqvOOAcWJIzxH77P/Skill-Kwizz---Project",
  },
  {
    name: "PayTrack – Salary & PF App",
    category: "UI/UX Mobile App",
    tags: ["Mobile", "Finance App"],
    videoSrc: "",
    imageBg: Paytrack,
    url: "https://www.figma.com/design/YtY5hltZmOC9r5VrXjhcxQ/Pay-Track",
  },
  {
    name: "Lil Stream – Kids OTT Platform",
    category: "UI/UX & OTT",
    tags: ["Kids App", "OTT"],
    videoSrc: "",
    imageBg: Stream,
    url: "https://www.figma.com/design/oVqecnVhMa5Fo5cPJAEBia/Lil-Stream",
  },
  {
    name: "CMRL Smartwatch UI",
    category: "Smartwatch UI Design",
    tags: ["Wearable UI", "Metro App"],
    videoSrc: "",
    imageBg: CMRS,
    url: "https://www.figma.com/design/ZpmC6sDNElS0Lif1ZPLjxA/CMRL",
  },
    {
    name: "EZON Website Redesign",
    category: "UI/UX Website",
    tags: ["Website", "Redesign"],
    videoSrc: "",
    imageBg: Ezon, // Add the EZON image import here
    url: "https://www.figma.com/design/pKNC7bz7JpS2Jo2HUVuUXR/The-Ezon---Redesign",
  },
   {
    name: "Parent Pal",
    category: "UI/UX & Parenting Website",
    tags: ["Parenting", "Blog"],
    videoSrc: "",
    imageBg: Paypal,
    url: "https://www.figma.com/design/IPK59EuHmPOeagqjsGqjIV/Parent-Pal",
  },
];

  // Reusable function to handle forward scroll animation
  const createForwardTimeline = (
    index: any,
    i: any,
    selectedWorksProps: any[],
  ) => {
    const tl = gsap.timeline({
      defaults: { duration: 0.3 },
    });

    // Set and move the #index element
    tl.set('#index', {
      yPercent: 100,
      onComplete: () => {
        index.value = Math.min(i, selectedWorksProps.length - 1);
      },
    }).to('#index', {
      yPercent: 0,
      ease: 'power1.inOut',
    });

    return tl;
  };

  // Reusable function to handle backward scroll animation
  const createBackwardTimeline = (index: any, i: any) => {
    const tl = gsap.timeline({ defaults: { duration: 0.3 } });

    // Set and move the #index element
    tl.set('#index', {
      yPercent: -100,
      onComplete: () => {
        index.value = Math.max(i, 0);
      },
    }).to('#index', {
      yPercent: 0,
      duration: 0.3,
      ease: 'power1.inOut',
    });

    return tl;
  };

  const handleIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      const video = entry.target as HTMLVideoElement;
      if (entry.isIntersecting) {
        video.play();
        video.classList.remove('blur');
      }
    });
  };
 
  const stopAllVideos = () => {
    videoRefs.value?.map((video: HTMLVideoElement) => {
      if (video && !video.paused) {
        video.pause();
        video.currentTime = 0; // Reset video to the start
      }
    });
  };
  onBeforeMount(() => {
    selectedWorks.value = textSplitterIntoChar('Selected Works / ', true);
  });

  onMounted(() => {
    stopAllVideos();

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.75, // Trigger when 75% of the video is visible
    });

    // Observe each video element
    videoRefs.value?.forEach((video) => {
      observer.observe(video);
    });

    animateSplitText(
      '#selectedWorks .letters',
      '#selected-works-text',
      0.7,
      0.01,
      0,
    );

    // Apply GSAP animations to each div
    if (!isSmallScreen.value)
      gsap.utils.toArray('.work-card').forEach((div: any, i: any) => {
        gsap.timeline({ defaults: { duration: 0.7 } }).to(div, {
          scrollTrigger: {
            trigger: div,
            // start: 'top 40%',
            start: 'top 25%',
            // end: 'bottom 40%',
            end: 'bottom 25%',
            scrub: 0.01,
            // markers: true,
            onLeaveBack: () => {
              // Backward scroll animation
              if (index.value !== 0) {
                gsap.to('#index', {
                  yPercent: 100,
                  duration: 0.3,
                  ease: 'power4.inOut',
                  onComplete: () => {
                    createBackwardTimeline(index, i - 1);
                  },
                });
              }
            },
          },
          ease: 'power1.inOut',
          onComplete: () => {
            // Forward scroll animation
            if (index.value !== selectedWorksProps.length - 1) {
              gsap.to('#index', {
                yPercent: -100,
                duration: 0.3,
                ease: 'power4.inOut',
                onComplete: () => {
                  createForwardTimeline(index, i + 1, selectedWorksProps);
                },
              });
            }
          },
        });
      });
  });
</script>
